import { Pipe, PipeTransform } from "@angular/core";
import { TemplatesService } from "../templates.service";

@Pipe({
  name: "searchFilter",
})
export class GrdFilterPipe implements PipeTransform {
  constructor(private templatesService: TemplatesService) {}
  transform(items: any, filter: any, defaultFilter: boolean = false): any {
    if (!filter) {
      this.templatesService.updateTemplatesArrPagination(items?.length || 0);
      return items;
    }
    if (!Array.isArray(items)) {
      this.templatesService.updateTemplatesArrPagination(items?.length || 0);
      return items;
    }

    if (filter && Array.isArray(items)) {
      let filterKeys = Object.keys(filter);

      if (defaultFilter) {
        const filteredItems = items.filter((item) =>
          filterKeys.reduce(
            (x, keyName) =>
              (x && new RegExp(filter[keyName], "gi").test(item[keyName])) ||
              filter[keyName] === "",
            true
          )
        );
        this.templatesService.updateTemplatesArrPagination(
          filteredItems?.length || 0
        );
        return filteredItems;
      } else {
        const filteredItems = items.filter((item) => {
          return filterKeys.some((keyName) => {
            return (
              new RegExp(filter[keyName], "gi").test(item[keyName]) ||
              filter[keyName] === ""
            );
          });
        });
        this.templatesService.updateTemplatesArrPagination(
          filteredItems?.length || 0
        );
        return filteredItems;
      }
    }
  }
}
